import { render, staticRenderFns } from "./vagueRaiod.vue?vue&type=template&id=b040dd56&scoped=true&"
import script from "./vagueRaiod.vue?vue&type=script&lang=js&"
export * from "./vagueRaiod.vue?vue&type=script&lang=js&"
import style0 from "./vagueRaiod.vue?vue&type=style&index=0&id=b040dd56&lang=scss&scoped=true&"
import style1 from "./vagueRaiod.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b040dd56",
  null
  
)

export default component.exports